const inneArr = [
  ['Hot-Dog', [], ['9', '00'], 1],
  ['Hamburger', [], ['10', '00'], 2],
  ['Cheesburger', [], ['11', '00'], 3],
  ['Hamburger XXL', [], ['17', '00'], 4],
  ['Cheesburger XXL', [], ['18', '00'], 5],
  ['Frytki', [], ['7', '00'], 6],
  ['Sałatka Vege/Kurczak', [], ['13', '00'], 7],
]

export default inneArr
